import * as React from 'react';
import type { SVGProps } from 'react';

const SvgShare = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 16" fill="none" {...props}>
    <path
      d="M12.124 6.46a2.775 2.775 0 0 0 2.772-2.772A2.775 2.775 0 0 0 12.124.915a2.775 2.775 0 0 0-2.707 3.366L5.042 6.583a2.77 2.77 0 0 0-2.166-1.047A2.775 2.775 0 0 0 .104 8.308a2.775 2.775 0 0 0 2.772 2.772c.879 0 1.661-.412 2.17-1.052l4.062 2.137q-.063.296-.064.608A2.93 2.93 0 0 0 11.97 15.7a2.93 2.93 0 0 0 2.926-2.927 2.93 2.93 0 0 0-2.926-2.926 2.92 2.92 0 0 0-2.26 1.07l-4.102-2.16q.038-.219.04-.45c0-.156-.017-.308-.041-.457l4.438-2.335c.51.578 1.252.945 2.079.945m-.154 4.774a1.54 1.54 0 1 1-.001 3.081 1.54 1.54 0 0 1 .001-3.081m-9.094-1.54A1.39 1.39 0 0 1 1.49 8.308c0-.764.622-1.386 1.386-1.386s1.386.622 1.386 1.386-.622 1.386-1.386 1.386m9.248-7.393a1.388 1.388 0 0 1 0 2.772 1.39 1.39 0 0 1-1.386-1.385c0-.765.622-1.387 1.386-1.387"
      fill="currentColor"
    />
  </svg>
);
export default SvgShare;
